import type React from 'react';

import { FilterIcon } from '@vlabs/icons';
import { Badge } from '@vlabs/uikit';
import type { IconButtonProps } from '@vlabs/uikit/components/controls/button/icon-button';
import { IconButton } from '@vlabs/uikit/components/controls/button/icon-button';

import { useSourceFilters } from './useSourceFilters';

interface SourceFilterMenuButtonProps extends IconButtonProps {
  isOpen: boolean;
  onToggle: VoidFunction;
}

function SourceFilterMenuButton({
  isOpen,
  onToggle,
  ...props
}: SourceFilterMenuButtonProps): React.JSX.Element {
  const { filters } = useSourceFilters();
  const filtersCount = [
    filters.statuses?.length ?? 0,
    filters.names?.length ?? 0,
    filters.reference ? 1 : 0,
  ].reduce((sum, count) => sum + count, 0);

  return (
    <IconButton
      badge={filtersCount > 0 ? <Badge value={filtersCount} /> : undefined}
      icon={<FilterIcon />}
      kind="secondary"
      onClick={onToggle}
      shape="square"
      size="small"
      variant={isOpen ? 'filled' : 'outlined'}
      {...props}
    />
  );
}

export { SourceFilterMenuButton };
